import { z } from 'zod';

export const GetCouponsCountServiceResponseSchema = z.object({
  totalCount: z.number().int().nonnegative().describe('전체 쿠폰 개수'),
  availableCount: z.number().int().nonnegative().describe('발급 가능 쿠폰 개수'),
});

export type GetCouponsCountServiceResponse = z.infer<typeof GetCouponsCountServiceResponseSchema>;
